<template>
  <component
    :entity="entity"
    :entity-id="entityId"
    :is="typeComponent"
    :is-nested-entity="isNestedEntity"
    :tab-data="tabData"
    v-on="$listeners"
  ></component>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  name: 'AppEntityTab',
  props: {
    isNestedEntity: {
      type: Boolean,
      default: false
    },
    tabData: {
      type: [Array, Object],
      default: () => []
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    tabType: {
      type: String,
      default: ''
    },
    entityId: {
      type: String,
      default: ''
    }
  },
  components: {
    propertiesItem: () => import('./TabProperties'),
    listItem: () => import('./TabList'),
    cards: () => import('./TabCards'),
    scheduleGeneral: () => import('./ScheduleGeneralTab'),
    notificationList: () => import('./NotificationsList.vue')
  },
  setup(props) {
    const typeComponent = computed(() => {
      switch (props.tabType) {
        case 'properties': {
          return 'propertiesItem';
        }
        case 'scheduleGeneral': {
          return 'scheduleGeneral';
        }
        case 'list': {
          return 'listItem';
        }
        case 'cards': {
          return 'cards';
        }
        case 'notifications': {
          return 'notificationList';
        }
        default:
          return false;
      }
    });

    return {
      typeComponent
    };
  }
};
</script>
